import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/lib/i18n";
import { blogScanContent } from "./content";

export function BlogScanWhyRefound() {
  const { language } = useLanguage();
  const c = blogScanContent[language].whyRefound;

  return (
    <section className="mx-auto max-w-[680px] px-4 sm:px-6 py-6">
      <h2 className="font-['Source_Serif_4'] text-2xl md:text-3xl font-semibold text-foreground mt-12 mb-5">
        {c.title}
      </h2>

      <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-6">
        {c.intro}
      </p>

      <p className="font-['Source_Serif_4'] text-base md:text-lg font-semibold text-foreground mb-4">
        {c.listTitle}
      </p>

      <ul className="space-y-3 mb-8">
        {(c.items as ReadonlyArray<string>).map((item, index) => (
          <li key={index} className="flex items-start gap-3">
            <CheckCircle2 className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
            <span className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85">
              {item}
            </span>
          </li>
        ))}
      </ul>

      <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
        {c.conclusion}
      </p>
    </section>
  );
}
